const availableNetworks = ['instagram', 'tiktok', 'youtube'];

export default availableNetworks;
